import React, { useState } from 'react';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import { Breadcrumbs, Divider } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { StyledBreadcrumb } from 'components/Breadcrumbs';
import {
  Home
} from '@material-ui/icons';
import Domains from './Domains';
import { adminConfigDomains } from 'utils/DomainUtils';
import Organizations from 'components/AdminConfig/Organizations';
import UserManagement from './UserManagement';

const tabs = [
  new Tab({ label: "User Management", value: "AddUser", scope: "AdminConfig", action: "create" }),
  new Tab({ label: "Domains", value: "Domains", scope: "AdminConfig", action: "create" }),
  new Tab({ label: "Organizations", value: "Organizations", scope: "AdminConfig", action: "create" })
]

const AdminConfig = () => {
  const [activeTab, setActiveTab] = useState("AddUser");

  return (
    <>
      <div style={{ padding: "0px 0px 16px 8px", marginTop: -8 }}>
      <Breadcrumbs aria-label="breadcrumb" >
        <StyledBreadcrumb
          component={Link}
          to={`/projects`}
          label={"home"}
          selected
          icon={<Home fontSize="small" />}
        />
        <StyledBreadcrumb
          component={Link}
          to={`/MFSConfiguration`}
          label="MFSConfiguration"
          selected
        />
      </Breadcrumbs>
      </div>
      <Divider style={{ marginBottom: 16 }}></Divider>
      <TabbedPage tabs={tabs} activeTab={activeTab} tabSetterFunc={setActiveTab}>
        
        {(() => {
          switch (activeTab) {
            case "AddUser": return <UserManagement />
            case "Domains": return <Domains domains={adminConfigDomains} />
            case "Organizations": return <Organizations />
            default: return <UserManagement />
          }
        })()}
      </TabbedPage>
    </>
  )
}

export default AdminConfig;